const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

export const geocodeLocation = async (locationName) => {
  if (!locationName) return null;

  try {
    const response = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
        locationName
      )}.json?access_token=${MAPBOX_TOKEN}&limit=1`
    );

    if (!response.ok) {
      throw new Error('Geocoding failed');
    }

    const data = await response.json();
    
    if (data.features && data.features.length > 0) {
      const [longitude, latitude] = data.features[0].center;
      return { longitude, latitude };
    }
    
    return null;
  } catch (error) {
    console.error(`Error geocoding ${locationName}:`, error);
    return null;
  }
};
